import React from 'react';
import { Container, ImageInfo, Preview } from './styles';

const ImageList = ({ images, onDelete }) => (
  <Container>
    {images.map((image, index) => !image.error && (
      <li key={index}>
        <ImageInfo>
          <Preview src={image.preview} />
          <button onClick={() => onDelete(index)}>Excluir</button>
        </ImageInfo>
      </li>
    ))}
  </Container>
);

export default ImageList;